module.exports = __webpack_public_path__ + "media/ai_video_anime.91a4a1a8.mp4";